var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-item",class:[
		_vm.variantClass,
		{ 'has-submenu': _vm.hasSubmenu },
		{ 'disabled': _vm.disabled }
	],on:{"click":function($event){!_vm.disabled && _vm.$emit('click')},"mouseenter":function($event){return _vm.$emit('mouseenter')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}},[_c('div',{staticClass:"menu-item__content"},[(_vm.icon)?_c('fluent-icon',{staticClass:"mr-2",attrs:{"icon":_vm.icon,"size":"16"}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.label))])],1),_vm._v(" "),(_vm.hasSubmenu)?_c('fluent-icon',{attrs:{"icon":"chevron-right","size":"12"}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }